import useQueryStatusBuilder from "hooks/useQueryStatusBuilder";
import { useMemo } from "react";
import useSWR, { SWRHook } from "swr";
import { Status } from "types/Status";

declare module "swr" {
  interface SWRResponse {
    status: Status;
  }
}

/**
 * @description
 * Wrapper around SWR to provide an
 * additional status value.
 */
const useQuery: SWRHook = (...args: any[]) => {
  const swrProps = useSWR(args[0], args[1], args[2]);

  const status = useQueryStatusBuilder({
    isLoading: swrProps.isLoading,
    isError: !!swrProps.error,
  });

  return useMemo(() => ({ ...swrProps, status }), [swrProps, status]);
};

export default useQuery;
